import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'router'
import { withTranslation } from 'react-i18next'

interface DeviceSizeCheckerProps {
  isMobileView: boolean
  onSizeChange?: (isMobileView: boolean) => void
  children?: React.ReactNode
}

const mapStateToProps = ({ appsettings }: any) => ({
  isMobileView: appsettings.isMobileView,
})

class DeviceSizeCheckerDef extends React.Component<DeviceSizeCheckerProps> {
  componentDidMount(): void {
    const { isMobileView, onSizeChange } = this.props
    if (onSizeChange != null) {
      onSizeChange(isMobileView)
    }
  }

  componentDidUpdate(prevProps: DeviceSizeCheckerProps): void {
    const { isMobileView, onSizeChange } = this.props
    if (prevProps.isMobileView !== isMobileView) {
      if (onSizeChange != null) {
        onSizeChange(isMobileView)
      }
    }
  }

  render(): React.ReactNode {
    const { children } = this.props

    return <React.Fragment>{children}</React.Fragment>
  }
}

const DeviceSizeChecker = connect(mapStateToProps)(
  withTranslation()(withRouter(DeviceSizeCheckerDef)),
)

export default DeviceSizeChecker
